<template>
	<div class="popup d-flex a-center j-center">
		<div class="popContent pr p3 d-flex f-colu a-center j-center">
			<div class="close d-flex a-center j-center pointer" @click="closePopup"><img src="@/assets/Icons/mixClose.png" alt=""></div>
			<div class="popText font-light">
				<slot></slot>
				<!-- <img src="@/assets/Icons/error.png" alt="">
				输入的Site ID与邮箱后缀不匹配！ -->
			</div>
		</div>
	</div>
</template>

<script>

export default {
  props: {
	  
  },
  data() {
    return {}
  },
  
  methods: {
	  closePopup() {
		  this.$parent.popupHandle = false;
	  }
  }
}

</script>

<style lang="less">
	.popup{
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,.3);
		z-index: 10;
		.popContent{
			width: 4.2rem;
			background: #fff;
			padding-top: .6rem;
			padding-bottom: .6rem;
			.popText{
				img{
					width: .4rem;
					margin-bottom: .2rem;
				}
			}
			.close{
				position: absolute;
				right: 0;
				top: 0;
				width: .5rem;
				height: .5rem;
				img{
					width: .15rem;
				}
			}
		}
	}
</style>
